module.exports = __webpack_public_path__ + "img/Sky.b6234df1.png";